<template>
  <h3>This is the homepage component</h3>
  <h6>
    You can find me in:
    <span class="px-2 py-1 bg-slate-100"
      >frontend/components/views/Home.vue</span
    >
  </h6>
  <p>Times clicked: {{ count }}</p>
  <button @click="increment">increment</button>
</template>

<script>
export default {
  data: () => ({
    count: 0,
  }),

  methods: {
    increment() {
      this.count++;
    },
  },
};
</script>
